<template>
	<header class="page-header">
		<nav class="page-header__breadcrumb" aria-label="breadcrumb">
			<NuxtLink class="page-header__breadcrumb-home" to="/">{{
				t(`${I18N_NS}.pageHeader.breadcrumbHome`)
			}}</NuxtLink>
			<span class="page-header__breadcrumb-sep" aria-hidden="true">&gt;</span>
			<span class="page-header__breadcrumb-current" aria-current="page">{{
				t(`${I18N_NS}.pageHeader.breadcrumbCurrent`)
			}}</span>
		</nav>

		<!-- <form class="page-header__search" @submit.prevent="emit('search')">
			<div class="search-bar">
				<img class="search-bar__icon" :src="iconSearch" alt="" aria-hidden="true" />
				<input
					:value="modelValue"
					class="search-bar__input"
					type="search"
					:placeholder="t(`${I18N_NS}.pageHeader.searchPlaceholder`)"
					@input="emit('update:modelValue', $event.target.value)"
				/>
				<span class="search-bar__divider" aria-hidden="true"></span>
				<button type="submit" class="search-bar__button">
					{{ t(`${I18N_NS}.pageHeader.searchButton`) }}
				</button>
			</div>
		</form> -->
	</header>
</template>

<script setup>
import iconSearch from "@variants/seer/service-institution/pc/image/Icon.svg";
import { useI18n } from "~/composables/useI18n";

const I18N_NS = "masterFortune";

const { t } = useI18n();

defineProps({
	modelValue: {
		type: String,
		default: "",
	},
});

const emit = defineEmits(["update:modelValue", "search"]);
</script>

<style lang="scss" scoped>
.page-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 24px;

	&__breadcrumb {
		display: flex;
		align-items: center;
		gap: 8px;
		font-size: 20px;
		line-height: 20px;
		white-space: nowrap;
	}

	&__breadcrumb-home {
		color: #333;
		font-weight: bold;
		text-decoration: none;
		transition: color 0.2s ease;

		&:hover {
			color: #f2af19;
		}
	}

	&__breadcrumb-sep {
		color: #999999;
		font-size: 16px;
	}

	&__breadcrumb-current {
		color: #f2af19;
		font-weight: 700;
	}

	&__search {
		flex-shrink: 0;
	}
}

.search-bar {
	position: relative;
	display: flex;
	align-items: center;
	width: 474px;
	height: 56px;
	padding: 0 106px 0 16px;
	border-radius: 53px;
	background: #f7f7f7;
	box-sizing: border-box;
	transition: background-color 0.2s ease;

	&:focus-within {
		background: #f2f2f2;
	}

	&__icon {
		flex-shrink: 0;
		width: 28px;
		height: 28px;
		margin-right: 18px;
	}

	&__input {
		flex: 1;
		min-width: 0;
		height: 100%;
		padding: 0;
		border: none;
		background: transparent;
		color: #333333;
		font-size: 18px;
		line-height: 1;
		outline: none;

		&::placeholder {
			color: #99a1af;
		}

		&::-webkit-search-cancel-button {
			display: none;
		}
	}

	&__divider {
		position: absolute;
		right: 106px;
		top: 50%;
		width: 1px;
		height: 20px;
		background: #dddddd;
		transform: translateY(-50%);
	}

	&__button {
		position: absolute;
		right: 0;
		top: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 106px;
		height: 56px;
		border: none;
		border-radius: 53px;
		background: transparent;
		color: #333333;
		font-size: 18px;
		color: #333333;
		cursor: pointer;
		transition: color 0.2s ease;

		&:hover {
			color: #333333;
		}
	}
}

@media (max-width: 1024px) {
	.page-header {
		flex-direction: column;
		align-items: stretch;
		gap: 16px;
		width: 100%;
		max-width: 100%;
		min-width: 0;
		box-sizing: border-box;

		&__search {
			width: 100%;
		}
	}

	.search-bar {
		width: 100%;
		max-width: 100%;
	}
}

@media (max-width: 900px) {
	.page-header {
		&__breadcrumb {
			font-size: 16px;
			line-height: 18px;
			white-space: normal;
			flex-wrap: wrap;
		}

		&__breadcrumb-sep {
			font-size: 14px;
		}
	}

	.search-bar {
		height: 48px;
		padding: 0 88px 0 14px;

		&__icon {
			width: 22px;
			height: 22px;
			margin-right: 12px;
		}

		&__input {
			font-size: 16px;
		}

		&__divider {
			right: 88px;
		}

		&__button {
			width: 88px;
			height: 48px;
			font-size: 18px;
		}
	}
}
</style>
